import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { ServiceManagerService } from '../service-manager.service';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
import { HttpMethod } from 'src/constants/constant';
@Component({
  selector: 'app-update-admin',
  templateUrl: './update-admin.component.html',
  styleUrls: ['./update-admin.component.scss']
})
export class UpdateAdminComponent implements OnInit {
  email = "";
  newEmail = "";
  confirmEmail = "";
  password = "";
  newPassword = "";
  confirmPassword = "";
  phoneNumber = "";
  newPhoneNumber = "";
  displayCurrentType: any = "";
  currentType: any = "";
  currentAction: any = "";
  availableDisplayName: any= {
    "email": "Email",
    "password": "Password",
    "phone_number": "Phone Number"
  }
  availableActions: any = {
    "email": "update_email",
    "password": "update_password",
    "phone_number": "update_phone_number"
  }
  showPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  constructor(private route: ActivatedRoute, public router: Router, public location: Location, public serviceManager: ServiceManagerService) { 
    this.getProfileDetails()

    this.route.queryParams
      .subscribe(params => {
        this.currentType = params['change'];
        this.displayCurrentType = this.availableDisplayName[this.currentType]
      }
    );
  }

  ngOnInit(): void {
  }

  getProfileDetails(){
    this.showPassword = false;
    this.showNewPassword = false;
    this.showConfirmPassword = false;
    this.serviceManager.CallBackendServiceAPI('get-profile-details', {}).subscribe( (data: any)=>{
      if(data){
        var profileDetails = data["profile_details"]
        this.email = profileDetails["email"]
        this.phoneNumber = profileDetails["help_and_support"]["phone_number"]
      }
    }) 
  }

  isValidForm(){
    if(this.currentType === "email"){
      return (this.serviceManager.isFilled(this.email) && 
              this.serviceManager.isFilled(this.newEmail) &&
              this.serviceManager.isFilled(this.confirmEmail) && 
              this.serviceManager.isFilled(this.password))
    }
    else if(this.currentType === "password"){
      return (this.serviceManager.isFilled(this.password) && 
              this.serviceManager.isFilled(this.newPassword) &&
              this.serviceManager.isFilled(this.confirmPassword) && 
              this.newPassword === this.confirmPassword)
    }
    else if(this.currentType === "phone_number"){
      return (this.serviceManager.isFilled(this.phoneNumber) && 
              this.serviceManager.isFilled(this.newPhoneNumber) && 
              this.serviceManager.isFilled(this.password))
    }
  }

  updateAdmin(){
    var body : any;
    if (this.currentType === "email"){
      body = {
        "email": this.email.trim(),
        "new_email": this.newEmail.trim(),
        "confirm_email": this.confirmEmail.trim(),
      }
    }
    else if (this.currentType === "password"){
      body = {
        "new_password": this.newPassword.trim(),
        "confirm_password": this.confirmPassword.trim()
      }
    }
    else if(this.currentType === "phone_number"){
      body = {
        "phone_number": this.phoneNumber.trim(),
        "new_phone_number": this.newPhoneNumber.trim()
      }
    }
    body["action"] = this.availableActions[this.currentType]
    body["password"] = this.password.trim()
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: true,
      createLoaderAction: true
    }
    this.serviceManager.CallBackendServiceAPI('update-admin', body, HttpMethod.POST, customOptions).subscribe( (data: any)=>{
      if(data){
        if(this.currentType !== "phone_number")
          this.serviceManager.logoutUser()
        else
          this.location.back()
      }
    }) 
  }

  navToForgotPassword(){
    localStorage.removeItem("idToken")
    this.router.navigate(['/forgot-password'])
  }
}
